import { NavbarMobile } from './NavbarMobile.jsx';

export default NavbarMobile;
